(()=>{'use strict';
const header=document.querySelector('.wgb-header--minimal');
if(!header)return;
const menu=header.querySelector('[data-mobile-menu]');
const toggle=header.querySelector('[data-menu-toggle]');
if(!menu||!toggle)return;
function close(){
  if(!menu.classList.contains('is-open'))return;
  menu.classList.remove('is-open');
  toggle.setAttribute('aria-expanded','false');
  toggle.setAttribute('aria-label','Open site menu');
}
toggle.addEventListener('click',()=>{
  toggle.setAttribute('aria-label',menu.classList.contains('is-open')?'Close site menu':'Open site menu');
});
document.addEventListener('keydown',event=>{
  if(event.key==='Escape'&&menu.classList.contains('is-open')){
    close();toggle.focus();
  }
});
document.addEventListener('pointerdown',event=>{
  if(menu.classList.contains('is-open')&&!header.contains(event.target))close();
});
menu.querySelectorAll('a').forEach(link=>link.addEventListener('click',close));
})();